<template>
    <CModal
        title="Редактирование блюда"
        :show.sync="modal.visible"
        :footer="false"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="entity"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">{{ entityTypeTitle }}</CCol>
                        <CCol 
                            sm="9"
                            class="col-form-label">
                            <span>{{ this.entity.label }}</span>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="entity_products"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Товар</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.entity_product && modal.item.entity_product.id">
                                <span class="order-gd-item-edit__title">{{ modal.item.entity_product.title }}</span>
                            </template>
                            <template v-else>
                                <Autocomplete
                                    ref="autocomplete"
                                    placeholder="Введите ID или часть названия"
                                    :search="getProducts"
                                    :get-result-value="getResultValue"
                                    @submit="updateProducts"
                                />
                            </template>
                            <!-- <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.entity_product ? modal.item.entity_product.id : null"
                                :options="entity_products"
                                placeholder="Выберите товар..."
                                @update:value="updateEntityProduct"
                            /> -->
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена блюда</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ +modal.item.entity_product.price }} р.
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id && entity_variants && entity_variants.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Модификаторы</CCol>
                        <template v-for="variant in entity_variants">
                            <CCol :key="variant.id" sm="6">
                                <CInputRadio
                                    class="mb-0"
                                    inline
                                    name="variant"
                                    :value="variant.id"
                                    :checked="selectedVariants === variant.id"
                                    @update:checked="updateVariants"
                                />{{ variant.title }} - {{ variant.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id && entity_options && entity_options.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Ингредиенты</CCol>
                        <template v-for="option in entity_options">
                            <CCol :key="option.id" sm="6">
                                <CInputCheckbox
                                    class="mb-0"
                                    inline
                                    :value="option.id"
                                    :checked="selectedOptions.indexOf(option.id) >= 0"
                                    @update:checked="updateOptions"
                                />{{ option.title }} - {{ option.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <!-- <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id"
                        form
                        class="form-group align-items-center">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">Применить скидку заказа</CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="modal.item.applyDiscount"
                                class="pt-1" />
                        </CCol>
                    </CRow>
                    <CRow v-if="modal.item.entity_product && modal.item.entity_product.id" class="form-group pl-3 danger">
                        В случае если к заказу применена скидка, к этой позиции она будет применена после обновления заказа.
                    </CRow> -->
                    <CRow
                        v-if="modal.item.entity_product && modal.item.entity_product.id && !modal.item.isNewPosition"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CLink
                    v-if="entityTypeCode"
                    :to="`/entities/${entityTypeCode}/${entity.value}/products/create`"
                    target="_blank">
                    <CButton
                        color="light"
                        class="ml-3" >
                            Создать новое блюдо 
                    </CButton>
                </CLink>
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!(modal.item.entity_product && modal.item.entity_product.id)"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Autocomplete from '@trevoreyre/autocomplete-vue';

    export default {
        name: 'OrderEDItemEdit',

        components: {
            Autocomplete,
        },

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                order: {},
                entity: null,
                entities: null,
                entityTypeTitle: '',
                entityTypeCode: '',
                entity_products: null,
                entity_variants: null,
                entity_options: null,
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
            selectedVariants() {
                return this.modal.item.entity_variants && this.modal.item.entity_variants.length ? this.modal.item.entity_variants[0].id : null;
            },
            selectedOptions() {
                return this.modal.item.entity_options.map(i => {
                    return i.id
                });
            },
        },

        watch: {
            visible: async function () {
                try {
                    const { data } = await Vue.axios.get(`/entities/get/${this.order.ed.items[0].entity_id}`);
                    if (data.entityType.code) {
                        this.entityTypeCode = data.entityType.code;
                    }

                    this.entity = {
                            value: data.id,
                            label: data.title,
                            code: data.code
                        }
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }

                if (!this.modal.item.entity_product.id) {
                    this.modal.item = {
                        ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                        ...{
                            id: this.modal.item.id,
                            entity: {
                                id: this.entity.value,
                                title: this.entity.label,
                                code: this.entity.code
                            },
                            isNewPosition: this.modal.item?.isNewPosition,
                        }
                    };
                }

                if(!this.modal.item.quantity) {
                    this.modal.item.quantity = 1
                }

                if(this.modal.item.entity && this.modal.item.entity.id) {
                    await this.getEntityProducts(this.modal.item.entity.id);
                }

                if(this?.modal?.item?.entity?.id && this?.modal?.item?.entity_product?.id) {
                    await this.getEntityProductOptions(this.modal.item.entity.id, this.modal.item.entity_product.id);
                    await this.getEntityProductVariants(this.modal.item.entity.id, this.modal.item.entity_product.id);
                }

                this.entityTypeTitle = this?.modal?.item?.entity?.entityType?.title
                ? this.modal.item.entity.entityType.title
                : 'Сервис';
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        async mounted() {
            const orderId = parseInt(this.$route.params.id);
            try {
                const orderResp = await Vue.axios.get(`/orders/${orderId}`);
                this.order = JSON.parse(JSON.stringify(orderResp.data));
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка при загрузке данных о заказе.');
            }
        },

        methods: {
            getProducts (search) {
                const id = this.order?.ed?.items[0]?.entity.id;

                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }

                    Vue.axios
                        .get(`/entities/${ id }/inactive_entity_products?search=${ search }`, {})
                        .then(resp => {
                            resolve(resp.data.results);
                        })
                        .catch(err => {
                            console.log('Cannot load dishes list.');
                        });
                });
            },
            async updateProducts(product) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                        id: this.modal.item.id,
                        entity: {
                            id: this.modal.item.entity.id,
                            title: this.modal.item.entity.title,
                            code: this.modal.item.entity.code,
                            entityType: {
                                code: this.modal.item.entity.code
                            }
                        },
                        entity_product: {
                            id: product.id,
                            title: product.title,
                            price: product.price
                        },
                        entity_product_id: product.id,
                        entity_product_title: product.title,
                        entity_product_price: product.price,
                        isNewPosition: this.modal.item?.isNewPosition,
                    }
                };
            },
            getResultValue(result) {
                return result.title;
            },
            formatDate(date) {
                return formatDate(date);
            },
            async getEntities() {
                const code = this?.modal?.item?.entity?.entityType?.code || this.modal.entityType ;
                try {
                    const { data } = await Vue.axios.get(`/entities/${code}`);
                    data.sort((a, b) => a.title > b.title ? 1 : -1);
                    this.entities = data.map(rest => {
                        return {
                            value: rest.id,
                            label: rest.title,
                            code: rest.code
                        }
                    });
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getEntityProducts(entityId) {
                try {
                    const { data } = await Vue.axios.get(`/entities/${entityId}/inactive_entity_products`);
                    this.entity_products = data.map(entity_product => {
                        return {
                            value: entity_product.id,
                            label: entity_product.title + ' - ' + entity_product.price + ' р.',
                            title: entity_product.title,
                            price: entity_product.price
                        }
                    });
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getEntityProductOptions(entityId, entity_productId) {
                try {
                    const { data } = await Vue.axios.get(`/entities/${entityId}/entity_products/get-options/${entity_productId}`);
                    this.entity_options = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getEntityProductVariants(entityId, entity_productId) {
                try {
                    const { data } = await Vue.axios.get(`/entities/${entityId}/entity_products/get-variants/${entity_productId}`);
                    this.entity_variants = data;

                    if(this.entity_variants && this.entity_variants.length && !this.selectedVariants) {
                        this.modal.item.entity_variants = [{
                            ...this.entity_variants[0]
                        }]
                    }
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            // async updateEntity(value) {
            //     for(let i=0; i < this.entities.length; i++) {
            //         if(value === this.entities[i].value) {
            //             console.log({
            //                 id: this.entities[i].value,
            //                 title: this.entities[i].label,
            //                 code: this.entities[i].code
            //             });
            //             this.modal.item = {
            //                 ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
            //                 ...{
            //                     id: this.modal.item.id,
            //                     entity: {
            //                         id: this.entities[i].value,
            //                         title: this.entities[i].label,
            //                         code: this.entities[i].code
            //                     },
            //                     isNewPosition: this.modal.item?.isNewPosition,
            //                 }
            //             };
            //         }
            //     }
            //     await this.getEntityProducts(this.modal.item.entity.id);
            // },
            async updateEntityProduct(value) {
                for(let i=0; i < this.entity_products.length; i++) {
                    if(value === this.entity_products[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                                id: this.modal.item.id,
                                entity: {
                                    id: this.modal.item.entity.id,
                                    title: this.modal.item.entity.title,
                                    code: this.modal.item.entity.code,
                                    entityType: {
                                        code: this.modal.item.entity.code
                                    }
                                },
                                entity_product: {
                                    id: this.entity_products[i].value,
                                    title: this.entity_products[i].title,
                                    price: this.entity_products[i].price
                                },
                                entity_product_id: this.entity_products[i].value,
                                entity_product_title: this.entity_products[i].title,
                                entity_product_price: this.entity_products[i].price,
                                isNewPosition: this.modal.item?.isNewPosition,
                            }
                        };
                    }
                }
                await this.getEntityProductOptions(this.modal.item.entity.id, this.modal.item.entity_product.id);
                await this.getEntityProductVariants(this.modal.item.entity.id, this.modal.item.entity_product.id);
                this.recalculatePrice();
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
            updateVariants(checked, obj) {
                for(let i=0; i < this.entity_variants.length; i++) {
                    if(+obj.target.value === this.entity_variants[i].id) {
                        this.modal.item.entity_variants = [{
                            ...this.entity_variants[i]
                        }];
                    }
                }
                this.recalculatePrice();
            },
            updateOptions(checked, obj) {
                if(checked) {
                    for(let i=0; i < this.entity_options.length; i++) {
                        if(+obj.target.value === +this.entity_options[i].id) {
                            this.modal.item.entity_options.push(this.entity_options[i]);
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.entity_options.length; i++) {
                        if(+obj.target.value === +this.modal.item.entity_options[i].id) {
                            this.modal.item.entity_options.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },
            recalculatePrice() {
                let price = +this.modal.item.entity_product.price;
                for(let i=0; i < this.modal.item.entity_variants.length; i++) {
                    price += +this.modal.item.entity_variants[i].price;
                }
                for(let i=0; i < this.modal.item.entity_options.length; i++) {
                    price += +this.modal.item.entity_options[i].price;
                }
                this.modal.item.price = price;
            }
        },
    };
</script>

<style scoped>
.danger {
    color: red;
}
</style>

